import i18next from 'i18next'
import { z, ZodString } from 'zod'

const isNaturalNumber = (value: string): boolean => /^\d*$/.test(value)

export const zNumericIntegerString: ZodString = z
  .string()
  .refine(isNaturalNumber, i18next.t('common:form.error.numericString'))
